/**
 * 探索クエリのうち detail 6 本 — 開く（API §5.1）。
 *
 * `getBusinessDetail` / `getOperationDetail` / `getScreenDetail` / `getSystemTestDetail` /
 * `getTermDetail` / `getMasterDetail` の 6 本。検索・一覧・フローの 7 本は
 * `exploration.ts` にある。
 * 分けてあるのは 1 ファイルの行数上限（`cortex-quality/max-code-lines`）に収めるためで、
 * 境界は「1 件を開いて周辺を導出する」か「集合を引く」かで切ってある。
 *
 * detail 系は**逆引きを導出値として返す**（制約 8・11）。`accessActors` のように
 * 入力に存在しない値もここで組み立てる — 一次表現は宣言側 1 箇所に残し、読取が
 * そこから導く（決定 a・y-4）。
 *
 * 親子関係は qualifiedName のパス構造から導く（`parentQualifiedName` /
 * `childQualifiedNamePrefix`）。親子を別の列やエッジから引き直さないのは、
 * ID 規約とパス構造という 2 表現が乖離しうるためである。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 探索クエリの detail 6 本。業務・操作・画面・総合テスト・用語・マスターの 1 件を周辺の導出値つきで返す
 * @graph-connects bigquery.spec_graph_nodes [reads_from, via:graphId] ノードの読取
 * @graph-connects bigquery.spec_graph_edges [reads_from, via:graphId] エッジの読取
 */
import { SPEC_LOCALES } from '../contract/locales.js';
/**
 * 用語が本文に当たった表記の種別。locale 名は正表記（その言語の表記）、`synonym` は揺れ表記。
 *
 * locale の一覧から組み立てているため、揃える言語を足せば当たり方の種別も同時に増える。
 * 手で並べると、増えた言語で当たった出現が黙って `synonym` に落ちる。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 用語の逆引き行が「どの表記で当たったか」を表す allowlist
 * @graph-connects none
 */
export const TERM_MATCH_KINDS = [...SPEC_LOCALES, 'synonym'];
//# sourceMappingURL=exploration-detail.js.map